import { RANDOM_BOARD_ID } from 'BoardID';
import { BoardType, Settings } from 'Types';

import BoardBase from 'boardClasses/BoardBase';
import { BOARD_CLASSES_BY_TYPE } from 'boardClasses/BoardClassByType';
import { createBoard, getCtor } from 'boardClasses/BoardFactory';
import { sample } from 'utils/utils';

export function generateRandomBoardHash(settings: Settings) {
  return generateRandomBoard(settings).getHash();
}

function generateRandomBoard(settings: Settings): BoardBase {
  const boardType = sample(settings.random.styles) || BoardType.Strips;

  return createBoard(
    getCtor(boardType),
    RANDOM_BOARD_ID,
    'Random',
    BOARD_CLASSES_BY_TYPE[boardType].createRandom(
      settings.random.materials,
      settings.random.size
    ),
    settings.units
  );
}
